import React from 'react'
import './Resume.css'
export default function About() {
    return (
        <div className='resume-container'>
            <div className="content">
                <h3>Resume</h3>
                <div className='golden-bar'></div>
                <div className="resume-container-bottom">
                    <div class="timeline-container">
                        <div class="timeline-section">
                            <div class="timeline-header">
                                <div class="timeline-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-book" viewBox="0 0 16 16">
                                        <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783" />
                                    </svg>
                                </div>
                                <h2>Education</h2>
                            </div>
                            <div class="timeline-content">
                                <div class="timeline-item">
                                    <div class="timeline-marker"></div>
                                    <div class="timeline-info">
                                        <h2>Institute of Management Sciences</h2>
                                        <span>2022 - Till now</span>
                                        <p>I am doing a bachelor's degree in software engineering from the institute.</p>
                                    </div>
                                </div>
                                <div class="timeline-item">
                                    <div class="timeline-marker"></div>
                                    <div class="timeline-info">
                                        <h2>Concordia College Nowshera</h2>
                                        <span>2020 - 2022</span>
                                        <p>I did an intermediate level computer science degree from this college.</p>
                                    </div>
                                </div>
                                <div class="timeline-item">
                                    <div class="timeline-marker"></div>
                                    <div class="timeline-info">
                                        <h2>The Pearl School and College Nowshera</h2>
                                        <span>2018 - 2020</span>
                                        <p>I did a metric level computer science degree from this institute.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="timeline-section">
                            <div class="timeline-header">
                                <div class="timeline-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-suitcase-lg" viewBox="0 0 16 16">
                                        <path d="M5 2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2h3.5A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5H14a.5.5 0 0 1-1 0H3a.5.5 0 0 1-1 0h-.5A1.5 1.5 0 0 1 0 12.5v-9A1.5 1.5 0 0 1 1.5 2zm1 0h4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1M1.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5H3V3zM15 12.5v-9a.5.5 0 0 0-.5-.5H13v10h1.5a.5.5 0 0 0 .5-.5m-3 .5V3H4v10z" />
                                    </svg>
                                </div>
                                <h2>Experience</h2>
                            </div>
                            <div class="timeline-content-2">
                                <div class="timeline-item">
                                    <div class="timeline-marker"></div>
                                    <div class="timeline-info">
                                        <h2>Internee.pk</h2>
                                        <span>Jan - Feb 2024</span>
                                        <p>I did an internship as a frontend developer at internee.pk. It was a 2-month internship.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="my-skills">
                        <h2 className='myskills-title'>My Skills</h2>
                        <div className="skills-container">
                            <div className="skill-item">
                                <p className="skill">web design <span>80%</span></p>
                                <div className="prgrs-bar">
                                    <div className='prgrs-bar-inner' style={{ width: "80%" }} ></div>
                                </div>
                            </div>
                            <div className="skill-item">
                                <p className="skill">HTML5 <span>80%</span></p>
                                <div className="prgrs-bar">
                                    <div className='prgrs-bar-inner' style={{ width: "80%" }} ></div>
                                </div>
                            </div>
                            <div className="skill-item">
                                <p className="skill">CSS3 <span>70%</span></p>
                                <div className="prgrs-bar">
                                    <div className='prgrs-bar-inner' style={{ width: "70%" }} ></div>
                                </div>
                            </div>
                            <div className="skill-item">
                                <p className="skill">JavaScript <span>70%</span></p>
                                <div className="prgrs-bar">
                                    <div className='prgrs-bar-inner' style={{ width: "70%" }} ></div>
                                </div>
                            </div>
                            <div className="skill-item">
                                <p className="skill">ReactJs <span>50%</span></p>
                                <div className="prgrs-bar">
                                    <div className='prgrs-bar-inner' style={{ width: "50%" }} ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}
